import { IPartnerParams } from '@/partners/partnerTypes';
import {
    EEasycarsParameters,
    EParameters,
} from '@/utils/setParametersFromParams';

import {
    getCaseInsensitiveParam,
    getCaseInsensitiveParamFromList,
} from '../getCaseInsensitiveParam';

import { ISetInitialVehicle } from './ISetInitialVehicle';

export function getInitialVehicleData(
    partner: IPartnerParams,
    params: URLSearchParams
): ISetInitialVehicle {
    console.log('* getInitialVehicleData', partner);

    return {
        buildYear: getCaseInsensitiveParamFromList(params, [
            EParameters.BUILD_YEAR,
            EEasycarsParameters.BUILD_YEAR,
            'buildyear',
            'buildYear',
            'BUILD_YEAR',
            'BUILDYEAR',
        ]),
        make: getCaseInsensitiveParam(params, EParameters.MAKE),
        model: getCaseInsensitiveParam(params, EParameters.MODEL),
        nvic: getCaseInsensitiveParam(params, EParameters.NVIC),
        sourceYardId: getCaseInsensitiveParam(
            params,
            EParameters.SOURCE_YARD_ID
        ),
        stockNumber: getCaseInsensitiveParamFromList(params, [
            EParameters.STOCK_NUMBER,
            EEasycarsParameters.STOCK_NUMBER,
        ]),
        variant: getCaseInsensitiveParam(params, EParameters.VARIANT),
        vehicleKilometers: getCaseInsensitiveParam(
            params,
            EParameters.KILOMETERS
        ),
        vehiclePrice: getCaseInsensitiveParam(params, EParameters.AMOUNT),
        vin: getCaseInsensitiveParam(params, EParameters.VIN),
        partnerId: partner.id,
        originalUrl: getCaseInsensitiveParam(params, EParameters.ORIGINAL_URL),
        vehicleCondition: {
            params: getCaseInsensitiveParam(params, EParameters.CONDITION),
            partner: partner.defaultVehicleCondition,
        },
        initialVehicleAssetType: {
            params: getCaseInsensitiveParamFromList(params, [
                EParameters.VEHICLE_TYPE,
                EParameters.ASSET_TYPE,
            ]),
            partner: partner.defaultVehicleAssetType,
        },
        initialVehicleAssetCategory: {
            params: getCaseInsensitiveParam(params, EParameters.ASSET_CATEGORY),
            partner: partner.defaultVehicleAssetCategory,
        },
    };
}
